/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const createCheckoutBodyCallbackUrlMax = 2048;

export const createCheckoutBodyExpiresInDefault = 900;
export const createCheckoutBodyExpiresInMin = 300;
export const createCheckoutBodyExpiresInMax = 3600;

export const CreateCheckoutBody = zod
	.object({
		actor: zod.object({
			email: zod.string().optional().describe('Optional actor email'),
			id: zod.string().describe("External actor ID from the customer's system"),
			kind: zod.enum(['human', 'agent']).optional(),
			metadata: zod.looseObject({}).optional().describe('Optional actor metadata'),
			name: zod.string().optional().describe('Optional actor name')
		}),
		callback: zod
			.object({
				method: zod.enum(['async_upload', 'url_upload', 'direct_upload']),
				url: zod
					.string()
					.max(createCheckoutBodyCallbackUrlMax)
					.describe('URL to receive callback with moderated content')
			})
			.optional(),
		context_id: zod
			.string()
			.optional()
			.describe("External context ID (e.g., post, conversation) from customer's system"),
		expires_in: zod
			.number()
			.min(createCheckoutBodyExpiresInMin)
			.max(createCheckoutBodyExpiresInMax)
			.default(createCheckoutBodyExpiresInDefault)
			.describe('Expiration time in seconds (default: 900)'),
		metadata: zod.looseObject({}).optional().describe('Optional metadata for the checkout'),
		praetor: zod.string().describe('Name of the praetor to use for this checkout')
	})
	.describe('Request to create a new checkout session');

export type CreateCheckoutBody = zod.input<typeof CreateCheckoutBody>;
export type CreateCheckoutBodyOutput = zod.output<typeof CreateCheckoutBody>;
